import { TranslationKey } from 'locales/fr';

export enum Routes {
    Home = '/',
    MenuHome = '/menu',
    Product = '/products/:productId',
    Payment = '/payment',
    NotFound = '/not-found',
    Cart = '/cart',
    OrderConfirmation = '/order/:orderId',
    OrderError = '/order-error',
    TermsAndConditions = '/terms-and-conditions',
}

export type RouteDeclaration = {
    name: TranslationKey;
    path: Routes;
    element: React.ReactElement;
    layout: React.ReactElement;
};
